module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('search-bar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-top": "-3em",
      "background": "#fff",
      "padding": "2em",
      "border-radius": "3px",
      "border": "1px solid rgb(211, 208, 208)"
    }
  }, [(_vm.data_server_ready) ? _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-8 col-lg-offset-2"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {}, [_vm._m(1), _vm._v(" "), _c('div', [(!_vm.view_info) ? _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "right",
      "background-color": "#fff",
      "color": "#22baae",
      "border": "#22baae solid"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.view_info = true;
        _vm.toggleComponent('info01');
      }
    }
  }, [_vm._v("\r\n                                                Ok, Noted, Collapse this info "), _c('i', {
    staticClass: "fa fa-angle-up",
    staticStyle: {
      "font-size": "1.6em"
    }
  })]) : _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "right",
      "background-color": "#fff",
      "color": "#22baae",
      "border": "#22baae solid"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.view_info = false;
        _vm.toggleComponent('info01');
      }
    }
  }, [_vm._v("\r\n                                                View Info "), _c('i', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "font-size": "1.6em"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('cndiscount-form', {
    attrs: {
      "cndiscount": _vm.cndiscount,
      "cndiscount_set_view": '',
      "payment_details_data": _vm.cndiscount_payment_data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('horizontal-widget')], 1)])])]), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h2', {
    staticStyle: {
      "font-weight": "bolder",
      "color": "#22baae",
      "text-align": "center"
    }
  }, [_vm._v("How To Setup a DiscountBazaar Code or Promo ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "info01"
    }
  }, [_c('p', [_vm._v("DiscountBazaar is a platform where businesses display \r\n                                                discounted goods and services for accelerated clearance sales.\r\n                                                When business is slow and  and you want to create a marketing buzz,\r\n                                                 or you have goods that are tying down money, setup DiscountBazaar and free your business capital.\r\n                                            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_c('b', [_vm._v("HOW TO SETUP DiscountBazaar")])]), _vm._v(" "), _c('p', [_vm._v("Click \"Setup DiscountBazaar\", a form will drop down. ")]), _vm._v(" "), _c('p', [_vm._v("The instructions with examples as numbered and listed below are a guide on how to fill the form:")]), _vm._v(" "), _c('p', [_vm._v("1). Sign in or create a Cityneeds account, if you don't have one.")]), _vm._v(" "), _c('p', [_vm._v("2). Under Business Settings, add/input the details of your business, if your business is not already on Cityneeds. \r\n                                                "), _c('br'), _vm._v("It is free!")]), _vm._v(" "), _c('p', [_vm._v("3). Select the listed business you want to setup DiscountBazaar for.")]), _vm._v(" "), _c('p', [_vm._v("4). Add a Caption-e.g. Buy One Get One Free.")]), _vm._v(" "), _c('p', [_vm._v("5). Add a Discount Code- e.g. BOGOF.")]), _vm._v(" "), _c('p', [_vm._v("6). Describe the Offer- e.g. Visit our shop, or go to our website, enter BOGOF at checkout, to get 40% discount on select items, while stock lasts.")]), _vm._v(" "), _c('p', [_vm._v("7). Add Discount Claim Link- e.g. If you have a website or a social media account where customers can purchase your product, enter the link. For example: https://quickstew.com")]), _vm._v(" "), _c('p', [_vm._v("8). Add Normal Price- This is the original market price of the product: e.g. 50000")]), _vm._v(" "), _c('p', [_vm._v("9). Add Discount Price- This is the reduced price you are offering to sell your product  for: e.g. 20000")]), _vm._v(" "), _c('p', [_vm._v("10). Add Media- Photo or Image  of the product on offer.")]), _vm._v(" "), _c('p', [_vm._v("11). Add the location where customers can find you- e.g. 10 Usuma street, Maitama.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db155f06"}!./src/components/CNdiscountSetup/template.html
// module id = 319
// module chunks = 0